export default (theme?: any, variant?: string): string => {
    let result = "blockButton1";

    try {
        if (variant && variant.toUpperCase() === "SECONDARY") {
            result = theme?.secondaryButton?.[0].content["_contentType"];
        }
        else if (variant && variant.toUpperCase() === "TERTIARY") {
            result = theme?.tertiaryButton?.[0].content["_contentType"];
        }
        else if (variant && variant.toUpperCase() === "ARROW") {
            result = theme?.arrowButton?.[0].content["_contentType"];
        }
        else {
            result = theme?.primaryButton?.[0].content["_contentType"];
        }
    }
    catch {
        // TODO
    }

    return result;
};